// src/components/QALayout/Layout1.js
import React, { useEffect } from 'react';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import QuestionCard from '../UI/QuestionCard';

const Layout1 = ({
  questions = [],
  showSource = false,
  className = '',
}) => {
  useEffect(() => {
    const grid = document.querySelector('.qa-grid');
    if (!grid || typeof Masonry === 'undefined' || typeof imagesLoaded === 'undefined') {
      console.error('Masonry or imagesLoaded is not loaded.');
      return;
    }

    if (window.msnry) {
      window.msnry.destroy();
      window.msnry = null;
    }

    imagesLoaded(grid, function () {
      const msnry = new Masonry(grid, {
        itemSelector: '.qa-grid__item',
        columnWidth: '.qa-grid__item',
        percentPosition: true,
        transitionDuration: '0.01s',
        gutter: 4,
      });

      window.msnry = msnry;

      const qaCards = grid.querySelectorAll('.qa-flip-card');
      qaCards.forEach((qaCard) => {
        const cardInner = qaCard.querySelector('.qa-flip-card__inner');
        const cardFront = qaCard.querySelector('.qa-flip-card__face--front');
        if (cardInner && cardFront) {
          cardInner.style.height = `${cardFront.offsetHeight}px`;
        }
      });

      msnry.layout();
    });

    return () => {
      if (window.msnry) {
        window.msnry.destroy();
        window.msnry = null;
      }
    };
  }, [questions]);

  return (
    <section
      className={`container-fluid qa-grid ${className}`.trim()}
      aria-label="Questions and Answers"
    >
      {questions.map((q) => (
        <QuestionCard
          key={q._id || q.id}
          question={q.question}
          answer={q.answer}
          detail={q.detail}
          source={showSource ? q.source : undefined}
        />
      ))}
    </section>
  );
};

export default Layout1;
